import { RestClient } from '@/api/rest-client'
import { Action } from '@/api/model/action'
import { Referral } from '@/api/model/referral'
import { cloneDeep } from 'lodash'
import { User } from '@/api/model/user'

export class ActionClient extends RestClient<Action> {
    collectionName = 'actions'
    parseData = Action.fromData

    async create(action: Action): Promise<Action> {
        const request = cloneDeep<any>(action)

        if (action.referral instanceof Referral) {
            request.referral = action.referral.resourceIdentifier
        }

        if (action.assignedTo) {
            request.assignedTo = action.assignedTo
                .filter((user: User) => user instanceof User)
                .map((user: User) => user.resourceIdentifier)
        }

        return super.create(request)
    }

    async update(id: string, data: any): Promise<Action> {
        const request = cloneDeep<any>(data)

        if (data.comment === null) {
            request.comment = ''
        }

        if (data.referral instanceof Referral) {
            request.referral = data.referral.resourceIdentifier
        }

        if (data.assignedTo) {
            request.assignedTo = data.assignedTo
                .filter((user: User) => user instanceof User)
                .map((user: User) => user.resourceIdentifier)
        }

        return super.update(id, request)
    }

    async getForUser(user: User): Promise<Action[]> {
        try {
            const response = await this.client.get(`${user.resourceIdentifier}/actions`)
            const collection = response.data['hydra:member'] as any[]
            return collection.map(value => this.parseData(value))

        } catch (error) {
            this.handleError(error)
        }
    }
}
